// One list row in the middle panel. `state` = "active" | "selected" | "idle".
// Active wins over selected. Bands are full-bleed (via -mx-5 px-5) and square.
export default function ListRow({ list, state, preview, onClick }) {
  const isActive = state === "active";
  const isSelected = state === "selected";

  const band = isActive
    ? "bg-[#E3F3EB]"
    : isSelected
    ? "bg-gray-100"
    : "hover:bg-gray-50";

  const symbols = preview?.symbols || [];
  // Preview line = up to 3 tickers + total count, e.g. "AVAX · BTC · XRP · 7 assets"
  // (matches the mobile picker).
  const count = preview?.count;
  const previewParts = [...symbols];
  if (typeof count === "number") {
    previewParts.push(`${count} ${count === 1 ? "asset" : "assets"}`);
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`block w-full px-3 py-3 text-left outline-none transition-colors focus:outline-none ${band}`}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="truncate text-[15px] font-semibold text-black">
          {list.name}
        </span>
        {isActive && (
          <span className="shrink-0 rounded-full bg-primaryColor px-2 py-0.5 text-[10px] font-semibold text-white">
            Active
          </span>
        )}
      </div>

      {isActive ? (
        <div className="mt-0.5 text-xs text-gray-500">Powers your Trade wheel</div>
      ) : previewParts.length > 0 ? (
        <div className="mt-0.5 truncate text-xs text-gray-400">{previewParts.join(" · ")}</div>
      ) : null}
    </button>
  );
}
